import React from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Float, Torus, MeshWobbleMaterial } from '@react-three/drei';
import { useRef } from 'react';

function Ring({ color = '#6b47dc' }) {
  const ref = useRef();
  useFrame((s) => { if (ref.current) ref.current.rotation.y = s.clock.getElapsedTime() * 0.8; });
  return (
    <group ref={ref}>
      <Torus args={[1, 0.14, 32, 64]}>
        <MeshWobbleMaterial color={color} factor={0.3} speed={1.5} metalness={0.6} roughness={0.2} />
      </Torus>
      <Torus args={[0.75, 0.08, 32, 64]} rotation={[Math.PI / 2, 0, 0]}>
        <meshStandardMaterial color="#ff5722" metalness={0.6} roughness={0.2} />
      </Torus>
    </group>
  );
}

export default function FloatingBadge({ color, height = '260px' }) {
  return (
    <div style={{ width: '100%', height }} className="canvas-wrap">
      <Canvas camera={{ position: [0, 0, 4], fov: 45 }} dpr={[1, 1.5]}>
        <ambientLight intensity={0.7} />
        <directionalLight position={[3, 3, 3]} intensity={1} />
        <Float speed={2} rotationIntensity={2} floatIntensity={2}>
          <Ring color={color} />
        </Float>
      </Canvas>
    </div>
  );
}
